export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW/SALES-CHALLENGE';

export function setCurrentView(payload) {
  return {
    type: SET_CURRENT_VIEW,
    payload,
  };
}
